import { createContext, useContext, useState, ReactNode } from 'react';
import { Modal } from 'antd';
import MapBox from './MapBox';

export type Coordinates = {
  latitude: string;
  longitude: string;
};

interface MapViewModalContextType {
  openMapViewModal: (coordinates: Coordinates) => void;
  closeMapViewModal: () => void;
}

const MapViewModalContext = createContext<MapViewModalContextType | null>(null);

export const useMapViewModal = () => useContext(MapViewModalContext)!;

export const MapViewModalProvider = ({ children }: { children: ReactNode }) => {
  const [coordinates, setCoordinates] = useState<Coordinates | null>(null);
  const [visible, setVisible] = useState(false);

  const openMapViewModal = (coordinates: Coordinates) => {
    setVisible(true);
    console.log('COORDINATES', coordinates);
    setCoordinates(coordinates);
  };

  const closeMapViewModal = () => {
    setVisible(false);
  };

  return (
    <MapViewModalContext.Provider
      value={{ openMapViewModal, closeMapViewModal }}
    >
      {children}

      <Modal
        open={visible}
        onCancel={closeMapViewModal}
        footer={null}
        destroyOnClose
        width={1000}
      >
        <div className="min-h-[500px] bg-orange-500">
          {coordinates && <MapBox coordinates={coordinates} />}
        </div>
      </Modal>
    </MapViewModalContext.Provider>
  );
};
